import { useOutletContext, Link } from "react-router-dom";
import { createRef, useEffect, useRef, useState } from "react";
import { releaseNotes } from "../../Assets/releaseNotes";
import { PageNames, APIDisplayNames, ChangeTypes, TabNames, PAGE_TITLE_BASE, PageDisplayNames } from "../../Assets/variables";
import { apiInfos } from "../../Assets/API/apiInfos";
import InnerNavigation from "../../Components/InnerNavigation";
import { goToSection } from "../../Utils/pageNavigationHelpers";
import { Helmet } from "react-helmet-async";

const ReleaseNote = (props) => {
    return (
        <div className="api-related-changes">
            <h3 ref={props.reference} id={props.id}>{props.noteEntry.title}</h3>
            <div>
                <VersionHistoryPageCategory isWithoutAPI={true} changeLog={props.changeLog} type={ChangeTypes.Added} categoryTitle={"Added"} />
                <VersionHistoryPageCategory isWithoutAPI={true} changeLog={props.changeLog} type={ChangeTypes.Changed} categoryTitle={"Changed"} />
                <VersionHistoryPageCategory isWithoutAPI={true} changeLog={props.changeLog} type={ChangeTypes.Deprecated} categoryTitle={"Deprecated"} />
                <VersionHistoryPageCategory isWithoutAPI={true} changeLog={props.changeLog} type={ChangeTypes.Removed} categoryTitle={"Removed"} />
                <VersionHistoryPageCategory isWithoutAPI={true} changeLog={props.changeLog} type={ChangeTypes.Fixed} categoryTitle={"Fixed"} />
                <VersionHistoryPageCategory isWithoutAPI={true} changeLog={props.changeLog} type={ChangeTypes.Security} categoryTitle={"Security"} />
            </div>
            <hr />
        </div>
    )
}

const ReleaseNoteByAPI = (props) => {

    function getApiName(apiDisplayName) {
        return apiInfos.filter(api => api.apiTitle === apiDisplayName)[0].apiName;
    }

    return (
        <div className="api-related-changes">
            <h3 ref={props.reference} id={props.id}><Link to={`/catalog/${getApiName(props.apiName)}/${TabNames.VersionHistory}`}>{props.apiName}</Link></h3>
            <div>
                <VersionHistoryPageCategory apiName={props.apiName} changeLog={props.changeLog} type={ChangeTypes.Added} categoryTitle={"Added"} />
                <VersionHistoryPageCategory apiName={props.apiName} changeLog={props.changeLog} type={ChangeTypes.Changed} categoryTitle={"Changed"} />
                <VersionHistoryPageCategory apiName={props.apiName} changeLog={props.changeLog} type={ChangeTypes.Deprecated} categoryTitle={"Deprecated"} />
                <VersionHistoryPageCategory apiName={props.apiName} changeLog={props.changeLog} type={ChangeTypes.Removed} categoryTitle={"Removed"} />
                <VersionHistoryPageCategory apiName={props.apiName} changeLog={props.changeLog} type={ChangeTypes.Fixed} categoryTitle={"Fixed"} />
                <VersionHistoryPageCategory apiName={props.apiName} changeLog={props.changeLog} type={ChangeTypes.Security} categoryTitle={"Security"} />
            </div>
            <hr />
        </div>
    )
}

const VersionHistoryPageCategory = (props) => {
    let changeLogEntries = {};

    Object.keys(releaseNotes).map(changelog => {
        changeLogEntries[changelog] = {};
        changeLogEntries[changelog].changeList = [];
        if (props.isWithoutAPI) {
            changeLogEntries[changelog].changeList = releaseNotes[changelog].changeList.filter((change) => change.apis.length === 0);
        } else {
            changeLogEntries[changelog].changeList = releaseNotes[changelog].changeList.filter((change) => change.apis.includes(props.apiName));
        }
        changeLogEntries[changelog].releaseDate = releaseNotes[changelog].releaseDate;
        changeLogEntries[changelog].majorVersion = releaseNotes[changelog].majorVersion;
        changeLogEntries[changelog].minorVersion = releaseNotes[changelog].minorVersion;
    });
    
    function hasCategory(logs, category) {
        let doesContain = [];

        logs.map(log => {
            doesContain.push(log.type)
        });

        return doesContain.includes(category);
    }

    function createMarkup(message) {
        return {__html: message};
    }

    return (
        <>
            { hasCategory(changeLogEntries[props.changeLog].changeList, props.type) && <>
                <div className="changenotes">
                    <ReleaseNoteChip type={props.type} />
                    { changeLogEntries[props.changeLog].changeList.map(entry => {
                        if (entry.type === props.type) {
                            return (
                                <div dangerouslySetInnerHTML={createMarkup(entry.message)}></div>
                            )
                        }
                    }) }
                </div>
            </>
            }
        </>
    )
}

function ReleaseNoteChip(props) {
    const type = props.type;

    if (type === ChangeTypes.Added) {
        return (
            <div className="note-type-chip note-type-chip--added">
                <span className="material-icons-outlined">add_circle_outline</span>
                <span className="chip-type">{ChangeTypes.Added}</span>
            </div>
        );
    }

    if (type === ChangeTypes.Deprecated) {
        return (
            <div className="note-type-chip note-type-chip--deprecated">
                <span className="material-icons-outlined">error_outline</span>
                <span className="chip-type">{ChangeTypes.Deprecated}</span>
            </div>
        );
    }

    if (type === ChangeTypes.Removed) {
        return (
            <div className="note-type-chip note-type-chip--removed">
                <span className="material-icons-outlined">remove_circle_outline</span>
                <span className="chip-type">{ChangeTypes.Removed}</span>
            </div>
        );
    }

    if (type === ChangeTypes.Changed) {
        return (
            <div className="note-type-chip note-type-chip--changed">
                <span className="material-icons-outlined">update</span>
                <span className="chip-type">{ChangeTypes.Changed}</span>
            </div>
        );
    }
}

const ReleaseNotes = () => {
    const {setActivePageItem} = useOutletContext();
    const headingRefs = useRef({});
    createRefsById();
    const [isShown, setIsShown] = useState({
        "2026-09-26": true,
        "2026-07-25": false,
        "2026-07-04": false,
        "2026-05-23": false,
        "2026-05-02": false,
        "2026-03-28": false,
        "2026-02-14": false,
        "2025-12-06": false,
        "2025-10-20": false,
        "2025-09-02": false,
        "2025-05-31": false,
        "2024-10-31": false,
        "2024-08-30": false,
        "2024-08-21": false,
        "2024-06-13": false,
        "2024-03-07": false,
        "2024-01-17": false,
        "2023-04-25": false
    });

    function createRefsById() {
        return Object.keys(releaseNotes).map(changeLogEntry => {
            { releaseNotes[changeLogEntry].changeList.map(noteEntry => {
                if (noteEntry.apis.length === 0) {
                    headingRefs.current[`${releaseNotes[changeLogEntry].majorVersion}/${releaseNotes[changeLogEntry].minorVersion}`] = createRef();
                }
            }) }
            { Object.values(APIDisplayNames).map(apiName => {
                if (apiHasChange(changeLogEntry, apiName)) {
                    headingRefs.current[`${releaseNotes[changeLogEntry].majorVersion}/${releaseNotes[changeLogEntry].minorVersion}-${getApiName(apiName)}`] = createRef();
                }
            }) }
        })
    }

    useEffect(() => {
        setActivePageItem(PageNames.ReleaseNotes);
        const currentUrl = window.location.href;
        const section = currentUrl.split("#")[1];
        if (section) {
            goToSection(headingRefs.current[section])
        }
    }, []);

    function getApiName(apiDisplayName) {
        return apiInfos.filter(api => api.apiTitle === apiDisplayName)[0].apiName;
    }

    function apiHasChange(changeLogEntry, apiName) {
        let hasChange = [];

        releaseNotes[changeLogEntry].changeList.map(change => {
            hasChange.push(!!change.apis.includes(apiName));
        })

        return hasChange.includes(true);
    }
    
    return (
        <>
            <Helmet>
                <title>{`${PAGE_TITLE_BASE}${PageDisplayNames.ReleaseNotes}`}</title>
                <meta name="description" content={`${PageDisplayNames.ReleaseNotes} page of the SIX Web API Portal`} />
                <link rel="canonical" href={`/${PageNames.ReleaseNotes}`} />
            </Helmet>
            <div className="release-notes">
                <div className="inner-navigation">
                    <InnerNavigation isShown={isShown} setIsShown={setIsShown} headingRefs={headingRefs.current} />
                </div>
                <div className="release-notes-list">
                    { Object.keys(releaseNotes).map(changeLogEntry => (
                        <div id={changeLogEntry} className="release-notes-log">
                            <div className="release-notes-log-inner">
                                <span className="header-2">{`Release: ${releaseNotes[changeLogEntry].releaseDate}`}</span>
                                <span className="header-3">{`Major Version ${releaseNotes[changeLogEntry].majorVersion} / Minor Version ${releaseNotes[changeLogEntry].minorVersion}`}</span>
                                <h2 className="hidden" id={`${releaseNotes[changeLogEntry].releaseDate}`}>{`Release: ${releaseNotes[changeLogEntry].releaseDate}`}</h2>
                                { releaseNotes[changeLogEntry].changeList.length > 0 && <div>
                                    { releaseNotes[changeLogEntry].changeList.map(noteEntry => (
                                        noteEntry.apis.length === 0 && <ReleaseNote reference={headingRefs.current[`${releaseNotes[changeLogEntry].majorVersion}/${releaseNotes[changeLogEntry].minorVersion}`]} changeLog={changeLogEntry} id={`${releaseNotes[changeLogEntry].majorVersion}/${releaseNotes[changeLogEntry].minorVersion}`} noteEntry={noteEntry} />
                                    )) }
                                    { Object.values(APIDisplayNames).map(apiName => (
                                        apiHasChange(changeLogEntry, apiName) && <ReleaseNoteByAPI reference={headingRefs.current[`${releaseNotes[changeLogEntry].majorVersion}/${releaseNotes[changeLogEntry].minorVersion}-${getApiName(apiName)}`]} apiName={apiName} changeLog={changeLogEntry} id={`${releaseNotes[changeLogEntry].majorVersion}/${releaseNotes[changeLogEntry].minorVersion}-${getApiName(apiName)}`} />
                                    )) }
                                </div>
                                }
                                { releaseNotes[changeLogEntry]?.initialRelease && <div>
                                    <p>Initial release</p>
                                </div>
                                }
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default ReleaseNotes;